import { generateEntityCrudActionTypes } from 'syft-acp-util/store/action-types'

const csatAgenciesCrudActionTypes = generateEntityCrudActionTypes('csatAgencies')

export default { ...csatAgenciesCrudActionTypes }
